import React, { useState } from 'react'

import { faCircleXmark, faFilter } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Dropdown, Menu } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

const TableFilters = ({ filters, parameters, onParametersChange, filterCount = 0, onReset }) => {
  const t = useSelector(selectTranslate)

  const [hovered, setHovered] = useState(false)

  return (
    <Dropdown
      overlay={
        <Menu>
          {filters.map((f, index) => {
            const extendedProps = {
              ...f.props,
              key: index,
              onChange: (i) => {
                const newFilters = { ...parameters.filters }

                newFilters[f.key] = i

                onParametersChange({ ...parameters, filters: newFilters, page: 1 })

                if (typeof f.props.onChange === 'function') {
                  f.props.onChange(i)
                }
              }
            }

            return (
              <Menu.ItemGroup key={index} title={f.label}>
                <Menu.Item disabled style={{ cursor: 'default' }}><f.component {...extendedProps} /></Menu.Item>
              </Menu.ItemGroup>
            )
          })}
        </Menu>
      }
      overlayClassName='custom-overlay'
      trigger={['click']}
    >
      <div
        className='filter-button-wrapper'
        style={{ position: 'relative', display: 'inline-block' }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {filterCount > 0 && hovered && (
          <span
            aria-hidden
            style={{
              position: 'absolute',
              right: '7px',
              top: '5px',
              zIndex: '100',
              cursor: 'pointer'
            }}
          >
            <FontAwesomeIcon
              size='xl' onClick={(e) => {
                onReset()
                e.stopPropagation()
              }} icon={faCircleXmark}
            />
          </span>
        )}

        <Button style={filterCount > 0 ? { color: '#52c41a', borderColor: '#52c41a' } : {}} className='flex-button'>
          <FontAwesomeIcon icon={faFilter} />
          {filterCount > 0 && <span style={{ marginLeft: '5px' }}> {filterCount} {filterCount === 1 ? t('filters.count.filter') : t('filters.count.filters')}</span>}
        </Button>
      </div>
    </Dropdown>
  )
}

export default TableFilters
